<template>
  <v-card>
    <v-data-table :headers="headers"
                  :items="images"
                  :options.sync="options"
                  :footer-props="dataTableFooterProps"
                  :server-items-length="totalImages"
                  :loading="imagesLoading"
                  disable-sort
                  loading-text="Loading... Please wait">

      <template v-slot:top>
        <v-card-title class="grey--text text--darken-2">
          <v-icon class="mx-3">
            mdi-file-image-outline
          </v-icon>
          Images
        </v-card-title>

        <v-card-title>
          <v-btn class="mr-5 ml-2"
                 rounded
                 color="primary"
                 dark
                 x-large
                 @click="addItem()"
          >
            <v-icon
            >
              mdi-plus
            </v-icon>
            Add an Image
          </v-btn>

          <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search Images"
              single-line
              hide-details
              filled
              rounded
              placeholder="Search images"
              class="mr-5"
              clearable
              @click="clear"
              color="primary"
          ></v-text-field>

          <RefreshTableHeader :action="refresh" />

        </v-card-title>
      </template>

      <template v-slot:item.url="{ item }">
        <v-img
            :src="item.url"
            max-height="100"
            max-width="150"
        ></v-img>
      </template>

      <template v-slot:item.actions="{ item }">

        <v-btn x-small
               depressed
               class="pa-3 ma-1"
               @click="editItem(item)">
          <v-icon small>
            mdi-pencil
          </v-icon>
        </v-btn>

        <v-btn
            x-small
            depressed
            @click="deleteItem(item)"
            class="pa-3 ma-1">
          <v-icon small color="primary">
            mdi-close
          </v-icon>
        </v-btn>
      </template>

      <template v-slot:[`footer.page-text`]="items">
        <RefreshTableFooter :item="items" :action="refresh"/>
      </template>

    </v-data-table>
    <ImageAdd/>
    <ImageEdit/>
    <ImageDelete/>
  </v-card>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import ImageAdd from "@/components/Images/ImageAdd";
import ImageEdit from "@/components/Images/ImageEdit";
import ImageDelete from "@/components/Images/ImageDelete";
import RefreshTableHeader from "@/components/common/RefreshTableHeader";
import RefreshTableFooter from "@/components/common/RefreshTableFooter";
import {debounce} from "@/utility";

export default {
  name: "Images",
  components: {
    RefreshTableHeader, RefreshTableFooter, ImageDelete, ImageEdit, ImageAdd,
  },
  computed: {
    ...mapState([
      'imagesLoading', 'totalImages',
    ]),
    ...mapGetters([
        'images', 'imagesLoading', 'totalImages', 'currentImageItem', 'dataTableFooterProps',
    ]),
  },
  methods: {
    ...mapActions([
      'getImages', 'getImage', 'clearImageApiError',
      'setOpenDialog', 'setImagesPaginationOptions', 'setImagesSearch',
    ]),
    selectImage() {
      this.previewImage = URL.createObjectURL(this.image);
    },
    addItem() {
      this.clearImageApiError();
      this.setOpenDialog('imageAdd');
    },
    async editItem(item) {
      this.clearImageApiError();
      this.setOpenDialog('imageEdit');
      await this.getImage(item);
      if (!this.currentCategoryItem) {
        this.getImages();
      }
    },
    async deleteItem(item) {
      this.clearImageApiError();
      this.setOpenDialog('imageDelete');
      await this.getImage(item);
      if (!this.currentImageItem) {
        this.getImages();
      }
    },
    refresh() {
      this.getImages();
    },
    clear() {
      this.setImagesSearch('');
    },
  },
  mounted() {
    this.setImagesSearch('');
    this.getImages();
  },
  data() {
    return{
      search: '',
      debouncedSearch: '',
      options: {
        itemsPerPage: 10,
      },
      headers: [
        {
          text: 'Thumbnail',
          align: 'start',
          value: 'url',
        },
        {
          text: 'Original Filename',
          align: 'start',
          value: 'originalName',
        },
        {
          text: 'ID',
          align: 'start',
          value: '_id',
        },
        {
          text: 'MimeType',
          align: 'start',
          value: 'mimeType',
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
        },
      ],
    };
  },
  watch: {
    options: {
      handler() {
        this.setImagesPaginationOptions(this.options);
        this.getImages();
      },
      deep: true,
    },
    search: debounce(function(newVal) {
      this.debouncedSearch = newVal;
    }, 500),
    debouncedSearch: {
      handler() {
        this.setImagesSearch(this.search ?? '');
        this.getImages();
      },
    },
  },
};
</script>